import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionTeam } from './competition-team'
import { competitionTeamActions } from './competition-team.actions'
import * as fromCompetitionTeam from './competition-team.reducer'
import { CompetitionTeamService } from './competition-team.service'

@Injectable()
export class CompetitionTeamEffects extends ResourceEffects<CompetitionTeam> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionTeamService: CompetitionTeamService
  ) {
    super(
      fromCompetitionTeam.FEATURE_NAME,
      competitionTeamService,
      competitionTeamActions,
      actions$
    )
  }
}
